import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
    selector: 'initiatormessage-app',
    templateUrl: 'initiatormessage.component.html',
    providers:[LoginService]
})

export class InitiatorMessageComponent implements OnInit {
    tempCollabos: any;
    collabosList:any;
    senderUserID:string;
    ChatRoomsByUsers:any;
    chatid:string;
    isview:boolean=false;
  collaboName: any;
  tempPraposaBids: any;
  collaboPraposals: any;
  usertype:string;
  pay_type: any;
  tempHiredCollaboDetails: any;
  HiredColaboDetals: any;
  EachCollaboHired: any;
  CollaboPraposalDetails=[];
  expandedIndex = 0;
  c:any;
  presentCollabos: any;
  searchText: any;
  tempcollaboslist: any;
  Accordian: any;
  private isCollapsed: boolean = true;
    constructor(private loginService:LoginService,private router:Router) { 
        this.senderUserID=localStorage.getItem('USERID');
        this.usertype=localStorage.getItem('userType');
      }

    ngOnInit() {
        this.GetCollabos();
        this.GetChatRooms();
        this.GetPraposalBids();
     }
     opencollabo(item){
      this.c=item;
    }
     GetChatRooms(){
        this.loginService.GetChatRooms().subscribe(data=>{
         data = JSON.parse(data['_body']);
         this.ChatRoomsByUsers=JSON.parse(JSON.stringify(data));
       
        })
      }
      GetPraposalBids(){
        this.loginService.GetPraposalBids().subscribe(data=>
          {
              data = JSON.parse(data['_body']);
              this.tempPraposaBids=JSON.parse(JSON.stringify(data));
    
    
    
          });
      }
      BackToCollaboList(){
        this.isview=false;
      }
      viewcollabo(row)
  {
    this.isview=true;
    this.viewcollabo=row;
    this.collaboName=row.title;
    this.pay_type=row.pay_type;
    let filterCollaboPraposals=this.tempPraposaBids.filter(x=>x.collaboid==row.id);
    if(filterCollaboPraposals.length>0){
      this.collaboPraposals=filterCollaboPraposals;
    }
    else{
      this.collaboPraposals=[];
    }

this.loginService.GetHiredCollabarators().subscribe(data=>
  {
      data = JSON.parse(data['_body']);
      this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));
let collabodetails:any

for(let i=0;i<this.collaboPraposals.length;i++ )
{
let hiredDetails=this.tempHiredCollaboDetails.filter(x=>x.collaboid==this.collaboPraposals[i].collaboid)
if(hiredDetails.length>0){
this.HiredColaboDetals=hiredDetails;


}
else{
this.HiredColaboDetals=[];

}
let filterHiredUsers=this.HiredColaboDetals.filter(x=>x.collaboid.toString()==this.collaboPraposals[i].collaboid && x.userid==this.collaboPraposals[i].userid)
let IsHired:boolean=false;
if(filterHiredUsers.length>0){
IsHired=true;
}else{
IsHired=false
}
// for(let j=0;j<this.collaboPraposals.length;i++){
this.CollaboPraposalDetails.push({
user_name:this.collaboPraposals[i].user_name,
IsHired:IsHired,
amount:this.collaboPraposals[i].amount,
collaboid:this.collaboPraposals[i].collaboid,
userid:this.collaboPraposals[i].userid,
bidstatus:this.collaboPraposals[i].bidstatus,
});
}

// }
// }
});

  }
  SaveHiringCollabarators(collaboid,userid,row){
        const json={
          rowid:"",
          colaboid:collaboid,
          userid:userid,
          createdbyparam:'admin',
          updatedbyparam:'admin'
        }
        this.loginService.SaveHiringCollabarators(json).subscribe(data=>{
    Swal.fire("Hired");
this.GetHiredCollabarators();
    
        })
      }
      Edit(row,name){
        if(name=='collabo'){
          this.router.navigate(['/messages',row.userid,'0',row.id]);
         
      }
      }
    SendMessage(row,name){
        if(name=='collabo'){
            this.router.navigate(['/messages',row.userid,'0',row.id]);
           
        }
        else{

        
        let filterChatRooms=this.ChatRoomsByUsers.filter(x=>x.userid.toString()==this.senderUserID.toString() && x.collaboid==row.collaboid);
        if(filterChatRooms.length>0){
        this.router.navigate(['/messages',row.userid,filterChatRooms[0].chatid,row.collaboid]);
         
        }
       else{
        const json={
          chatid:this.chatid,
          userid:this.senderUserID,
          createdbyparam:'admin',
          updatedbyparam:'admin',
          collaboid:row.collaboid,
          receiveruserid:row.userid
        }
        this.loginService.SaveChatRoomByUserID(json).subscribe(data=>{
          this.GetChatRooms();
        })
      
        // this.IsMessage=true;
       }
    }
      
    }
    GetHiredCollabarators(){
      this.loginService.GetHiredCollabarators().subscribe(data=>
        {
            data = JSON.parse(data['_body']);
            this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));
  
        });
    }
     SendM(row){
       console.log(row)
    this.GetChatRooms();
    let filterChatRooms=this.ChatRoomsByUsers.filter(x=>x.userid.toString()==this.senderUserID.toString() && x.receiveruserid==row.userid&& x.collaboid==row.collaboid);
    
    console.log(filterChatRooms)
    if(filterChatRooms.length>0){
     
    this.router.navigate(['/messages',row.userid,filterChatRooms[0].chatid,row.collaboid]);
     
    }
   else{
    const json={
      chatid:this.chatid,
      userid:this.senderUserID,
      createdbyparam:'admin',
      updatedbyparam:'admin',
      collaboid:row.collaboid,
      receiveruserid:row.userid
    }
    this.loginService.SaveChatRoomByUserID(json).subscribe(data=>{
      console.log(data)
      let chatid=data['_body']
      this.GetChatRooms();
    this.router.navigate(['/messages',row.userid,chatid,row.collaboid]);
    })
    //this.msg.newMessage('',row.user_name);
    //this.IsMessage=true;
   }
  }
    OpenMsgs(p){
      this.SendMessage(p,'collabo');
    }
    calculateDiff(sentDate,enddate) {
        var date1:any = new Date(sentDate);
        var date2:any = new Date(enddate);
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
      
        return diffDays;
      }
      Searchtext(){
        this.collabosList=[];
        this.collabosList=this.presentCollabos;
        this.tempcollaboslist = this.collabosList;
         let tempCompany = this.collabosList.filter(
           (item) => {
             return (
               (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
             );
           }
        
         );
         this.collabosList = tempCompany;
         
      }
      GetCollabos(){
          this.tempCollabos=[];
          this.collabosList=[];
        this.loginService.GetCollabos(this.usertype).subscribe(data=>
          {
            data = JSON.parse(data['_body']);
            this.tempCollabos=JSON.parse(JSON.stringify(data));
      
            let filterCollabos=this.tempCollabos.filter(x=>x.userid.toString()==this.senderUserID.toString());
            if(filterCollabos.length>0){
              this.collabosList=filterCollabos;
            }
            else{
              this.collabosList=[];
            }
            this.c=this.collabosList[0];
           this.presentCollabos=this.collabosList;
    });
  }
  accordianValue(value)
  {
    this.Accordian=value;
  }
}
